export async function getList({commit}, payload) {
  const {errResponse, data: responseData} = await this.$adminRepositories.companies.index(payload);
  if (!errResponse && responseData.success) {
    responseData.data.data = responseData.data.data.map(company => {
      company.roleList = company.roles.map(role => role.id);

      return company;
    })

    return commit('setList', responseData.data);
  }

  return [];
}

export async function getBusiness({commit}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.businesses.index();
  if (!errResponse && responseData.success) {
    return commit('setBusiness', responseData.data);
  }

  return [];
}

export async function updateRole({commit}, payload) {
  const response = await this.$adminRepositories.companies.updateRole(payload);

  if(!response.errResponse) {
    commit('updateRoleById', {id: payload.id, roles: response.data.data})
  }
}

export async function createCompany({commit}, payload) {
  commit('showPageLoading', true, {root: true});
  const response = await this.$adminRepositories.companies.create(payload);
  commit('hidePageLoading', false, {root: true});
  return response;
}

export async function updateCompany({commit}, payload) {
  commit('showPageLoading', true, {root: true});
  const response = await this.$adminRepositories.companies.update(payload.id, payload);
  commit('hidePageLoading', false, {root: true});
  return response;
}

export async function updateCompanyType({commit}, payload) {
  commit('showPageLoading', true, {root: true});
  const response = await this.$adminRepositories.companies.updateType(payload.id, payload);
  commit('hidePageLoading', false, {root: true});
  return response;
}

export async function deleteCompanyById({dispatch}, payload) {
  await this.$adminRepositories.companies.delete(payload.id)
}

export async function findCompanyById({commit}, payload) {
  const {errResponse, data: responseData} = await this.$adminRepositories.companies.show(payload);
  if (!errResponse && responseData.success) {
    return commit('setCompany', responseData.data);
  }

  return [];
}

export async function getAll({commit}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.companies.all();

  if (!errResponse && responseData.success) {
    return commit('setAll', responseData.data);
  }

  return [];
}

export async function getAll2({commit}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.companies.all();

  if (!errResponse && responseData.success) {
    return responseData.data
  }

  return [];
}